import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Capture-phase listener: railsui-dropdown-menu#select calls stopPropagation,
    // which blocks bubble-phase handlers (e.g. data-action on a parent wrapper).
    // Registering here keeps that requirement in this controller instead of the view.
    this.boundNavigate = this.navigate.bind(this)
    this.element.addEventListener("click", this.boundNavigate, true)
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundNavigate, true)
  }

  navigate(event) {
    const row = event.target.closest("[data-quiz-results-selector-url]")
    if (!row) {
      return
    }

    const url = row.dataset.quizResultsSelectorUrl
    if (!url || url === "#") {
      return
    }

    event.preventDefault()
    Turbo.visit(url)
  }
}
